// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadBar_wrapper__hkLuE"};